/**
 * Feature 104: canonical chooser copy, adopted verbatim from the Product
 * design reference (openspec/changes/feature-104-care-concierge-access-revamp/
 * design-reference/). Kept behind constants so Product edits are single-line.
 */
import type { ConsultationTier } from '../conciergeCalendly';

export const CHOOSER_HEADING = 'How would you like to connect?';

/**
 * The paid consultation's fee, as displayed. Named so surfaces outside the chooser — the FA
 * dashboard's self-pay button (Feature 106) — quote the same figure instead of hardcoding their
 * own. The backend's invitation email still carries its own copy, because it cannot import this.
 */
export const CONSULTATION_FEE_LABEL = '$350';

export type ChooserOptionId = 'details' | ConsultationTier;

export type ChooserOption = {
  id: ChooserOptionId;
  title: string;
  badges: { label: string; tone: 'free' | 'time' | 'price' }[];
  bestFor: string;
  youGet: string;
  /** Segment to bold inside youGet (the design's only bolded phrase). */
  youGetEmphasis?: string;
  cta: string;
};

// The free 15-minute intro option was removed (2026-08-24 Kirkland call): a
// free option beside the paid one cannibalized consultations; the team offers
// the intro call themselves when a form submission needs it.
export const CHOOSER_OPTIONS: ChooserOption[] = [
  {
    id: 'details',
    title: 'Send us your details',
    badges: [{ label: 'Free', tone: 'free' }],
    bestFor: "You'd rather write it out",
    youGet: 'Our Care Concierge team reviews your situation and reaches out',
    cta: 'Start writing →',
  },
  {
    id: '60min',
    title: 'Full consultation',
    badges: [
      { label: '60 min', tone: 'time' },
      { label: CONSULTATION_FEE_LABEL, tone: 'price' },
    ],
    bestFor: 'Complex, multi-decision, or urgent situations',
    youGet:
      'A one-on-one review of your needs, urgency, and options — plus a written Care Concierge Recap with personalized recommendations, timing guidance, and vetted providers. Optional follow-up support available',
    youGetEmphasis: 'Care Concierge Recap',
    cta: 'Book consultation →',
  },
];

export const BACK_TO_OPTIONS = '← Back to options';
